type MakeOptional<Type, Key extends keyof Type> = Omit<Type, Key> &
    Partial<Pick<Type, Key>>;

export const defaultInput = {
    intervalLength: 60,
    calendarStart: 6,
    calendarEnd: 23,
} as const;

export interface InputData {
    weeks: number;
    doctorId: number;
    container: string;
    doctorName: string;
    doctorPic: string;
    onCancelReservation: (id: number, reason: string) => Promise<any>;
    onSaveCalendar: (data: CalendarData) => Promise<any>;
    onModifyProfile: () => void;
    onChangeConsultationButtonClick?: () => void;
    onChangeConsultationClose?: () => void;
    onStartEndTimeError?: () => void;
    changeWithoutSave?: () => void;
    calendarData: CalendarData;
    calendarStart: number;
    calendarEnd: number;
    intervalLength: number;
    withoutEditProfile?: boolean;
}

export type InputDataWithDefaults = MakeOptional<
    InputData,
    keyof typeof defaultInput
>;

export interface CalendarSettings {
    calendarStart: number;
    calendarEnd: number;
    intervalLength: number;
    withoutEditProfile?: boolean;
}

export interface CalendarData {
    individualWeekSettings: IndividualWeekSettings;
    regularWeekSettings: RegularWeekSettings;
    reservations: Reservation[];
    otherReservations: RestrictedReservation[];
    rooms: Room[];
    specializations: Specialization[];
}

export interface Specialization {
    specialization: string;
    specialization_id: number | string;
}

export interface Room {
    id: number;
    name: string;
}

export interface RestrictedReservation {
    date: string;
    datetime: string;
    start: string;
    end: string;
}

export interface Reservation extends RestrictedReservation {
    id: number;
    patient: string;
    service: string;
    speciality: string;
    born: string;
    video_consultation: boolean;
}

export interface RegularWeekSettings {
    even: Week;
    odd: Week;
    oddWeekUsed: boolean;
}

export interface IndividualWeekSettings {
    [key: string | number]: Weeks;
}

// interface IndividualWeekSettingsObject {
//     [key: string]: Weeks;
// }
//
// export type IndividualWeekSettings = IndividualWeekSettingsObject | Weeks[];

export interface Weeks {
    [key: string]: Week;
}

export type Week =
    | { [key: string | number]: Consultation[] }
    | Consultation[][];

export interface Consultation {
    start: string;
    end: string;
    room_id: string | null;
    specialization_id: number[];
    domain_restriction?: unknown; // Unused
}

export interface Profile {
    doctorName: string;
    doctorPic: string;
    id: number;
}

export interface InputCallbacks {
    onCancelReservation: (id: number, reason: string) => Promise<any>;
    onSaveCalendar: (data: CalendarData) => Promise<any>;
    onModifyProfile: (doctorId: number) => void;
    onChangeConsultationButtonClick?: () => void;
    onChangeConsultationClose?: () => void;
    onStartEndTimeError?: () => void;
    changeWithoutSave?: () => void;
}
